import { AccountDispatcher } from './account-dispatcher.service';

export const dispatchers = [AccountDispatcher];

export { AccountDispatcher };
